import { useResidentContext } from "app/features/residents/provider/ResidentProvider";
import { useShowMedicationQuery } from "app/services/api/medicationsApi";
import { MedicationModel } from "app/services/api/types/medications/models/MedicationModel";
import { RootState } from "app/services/store";
import { selectResidentActiveMedicationById } from "app/store/slices/medications";
import { selectIsOnline } from "app/store/slices/network";
import { useMemo } from "react";
import { useSelector } from "react-redux";

export function useMedicationItemWithOffline({
  medicationId,
}: {
  medicationId: number | string;
}) {
  const { residentId } = useResidentContext();
  const isOnline = useSelector(selectIsOnline);
  const offlineData = useSelector((state: RootState) =>
    selectResidentActiveMedicationById(state, residentId, Number(medicationId)),
  ) as MedicationModel;

  const {
    data: onlineData,
    isFetching,
    isLoading,
    isError,
  } = useShowMedicationQuery(
    { medication: Number(medicationId) },
    { skip: !medicationId },
  );

  const data = useMemo(() => {
    if (isFetching || (isOnline && onlineData)) return onlineData;
    if (isError && offlineData) return offlineData;
    return onlineData;
  }, [onlineData, offlineData, isOnline, isFetching, isError]);

  return {
    data,
    isFetching,
    isLoading,
  };
}
